import API from "./API";

const getApiOrigin = () => {
  const base = String(API?.defaults?.baseURL || "").trim();
  if (!base) return "";

  try {
    const parsed = new URL(base);
    return `${parsed.protocol}//${parsed.host}`;
  } catch {
    return base.replace(/\/api\/?$/i, "").replace(/\/+$/, "");
  }
};

export const resolveAvatarUrl = (userLike) => {
  const raw = String(userLike?.avatar || userLike?.avater || "").trim();
  if (!raw) return "";

  if (/^data:image\//i.test(raw)) return raw;
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("/")) {
    const origin = getApiOrigin();
    return origin ? `${origin}${raw}` : raw;
  }

  return raw;
};

export const getAvatarInitial = (nameValue) => {
  const v = String(nameValue || "").trim();
  if (!v) return "U";
  return v[0].toUpperCase();
};

